import { Navigate, useLocation } from 'react-router-dom';
import { useMe } from '../../../shared/common/useMe';
import { hasRestrictedClubUserRole } from '../../../shared/common/roleAccess';
import { ALLOWED_ROLES } from '../../../shared/common/BlockedPage';
import ErrorBoundary from '../../../shared/common/ErrorBoundary';

const PrivateRoute = ({ element: Component, blockRestrictedClubUsers = false, ...rest }) => {
    const isAuthenticated = !!localStorage.getItem('user_id');
    const location = useLocation();
    const { me, loading } = useMe();

    if (!isAuthenticated) return <Navigate to="/" />;
    if (loading) return null;

    if (me && me.roles && me.roles.length > 0 && !me.roles.some(r => ALLOWED_ROLES.includes(r))) {
        return <Navigate to="/blocked" />;
    }

    if (blockRestrictedClubUsers && hasRestrictedClubUserRole(me)) {
        return <Navigate to="/overview" replace />;
    }

    return (
        <ErrorBoundary resetKey={location.pathname}>
            <Component {...rest} />
        </ErrorBoundary>
    );
};

export default PrivateRoute;
